import script from "./ProductsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsTable.vue?vue&type=script&setup=true&lang=js"

import "./ProductsTable.vue?vue&type=style&index=0&id=73bc2b2b&lang=scss"

const __exports__ = script;

export default __exports__